(function(){
  var drawer=document.getElementById('drawer');
  if(drawer){
    var openBtn=document.querySelector('[data-drawer-open]');
    var closeBtn=drawer.querySelector('[data-drawer-close]');
    var set=function(o){drawer.classList.toggle('is-open',o);document.body.classList.toggle('no-scroll',o);if(openBtn)openBtn.setAttribute('aria-expanded',o);if(o&&closeBtn)closeBtn.focus();};
    if(openBtn)openBtn.addEventListener('click',function(){set(true)});
    if(closeBtn)closeBtn.addEventListener('click',function(){set(false)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false)});
  }
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        main.src=b.dataset.src;main.srcset=b.dataset.srcset||'';if(b.dataset.ratio&&main.parentNode)main.parentNode.style.setProperty('--ratio',b.dataset.ratio);
        g.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.setAttribute('aria-current',x===b)});
      });
    });
  });
  var sort=document.querySelector('[data-sort]');
  if(sort)sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString();});
})();

/* Onderdelen zoeken: filtert de getoonde onderdelen op merk, model, categorie en woord */
(function(){
  document.querySelectorAll('[data-finder]').forEach(function(finder){
    var scope = finder.closest('section') || document;
    var selMerk = finder.querySelector('[data-f="merk"]'),
        selModel = finder.querySelector('[data-f="model"]'),
        selCat = finder.querySelector('[data-f="cat"]'),
        inpZoek = finder.querySelector('[data-f="zoek"]'),
        count = finder.querySelector('[data-count]'),
        results = scope.querySelector('[data-results]'),
        empty = scope.querySelector('[data-empty]'),
        chips = scope.querySelectorAll('[data-chip]');
    if(!results) return;
    var items = Array.prototype.slice.call(results.querySelectorAll('.card'));

    // Modellen per merk afleiden uit de getoonde onderdelen
    var modellen = {};
    items.forEach(function(el){
      var merk = el.dataset.merk, model = el.dataset.model;
      if(!merk || !model) return;
      if(!modellen[merk]) modellen[merk] = [];
      if(modellen[merk].indexOf(model) === -1) modellen[merk].push(model);
    });
    Object.keys(modellen).forEach(function(k){ modellen[k].sort(); });

    function vulModellen(){
      var merk = selMerk.value, lijst = modellen[merk] || [];
      selModel.innerHTML = '';
      if(!merk || !lijst.length){
        selModel.disabled = true;
        selModel.appendChild(new Option(merk ? 'Geen modellen bekend' : 'Kies eerst een merk', ''));
        return;
      }
      selModel.disabled = false;
      selModel.appendChild(new Option('Alle modellen', ''));
      lijst.forEach(function(m){ selModel.appendChild(new Option(m, m)); });
    }

    function filter(){
      var merk = selMerk.value, model = selModel.value, cat = selCat.value,
          zoek = (inpZoek.value || '').trim().toLowerCase(), n = 0;
      items.forEach(function(el){
        var ok = (!merk || el.dataset.merk === merk)
              && (!model || el.dataset.model === model)
              && (!cat || el.dataset.cat === cat)
              && (!zoek || el.dataset.zoek.indexOf(zoek) > -1);
        el.hidden = !ok;
        if(ok) n++;
      });
      if(count) count.textContent = n;
      naarLink();
      if(empty) empty.hidden = n > 0;
      results.hidden = n === 0;
      chips.forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.chip === cat); });
    }

    // Filters uit de link overnemen, zodat een gefilterd overzicht te delen is
    function uitLink(){
      var q = new URLSearchParams(window.location.search);
      var merk = q.get('merk') || '', model = q.get('model') || '',
          cat = q.get('cat') || '', zoek = q.get('q') || '';
      if(merk && [].some.call(selMerk.options, function(o){ return o.value === merk; })){
        selMerk.value = merk;
      }
      vulModellen();
      if(model && [].some.call(selModel.options, function(o){ return o.value === model; })){
        selModel.value = model;
      }
      if(cat && [].some.call(selCat.options, function(o){ return o.value === cat; })){
        selCat.value = cat;
      }
      if(zoek) inpZoek.value = zoek;
    }

    function naarLink(){
      if(!window.history || !window.history.replaceState) return;
      var q = new URLSearchParams();
      if(selMerk.value) q.set('merk', selMerk.value);
      if(selModel.value) q.set('model', selModel.value);
      if(selCat.value) q.set('cat', selCat.value);
      if(inpZoek.value.trim()) q.set('q', inpZoek.value.trim());
      var s = q.toString();
      try {
        window.history.replaceState(null, '', s ? '?' + s : window.location.pathname);
      } catch (e) {
        // sommige omgevingen staan dit niet toe, de filters blijven gewoon werken
      }
    }

    selMerk.addEventListener('change', function(){ vulModellen(); filter(); });
    selModel.addEventListener('change', filter);
    selCat.addEventListener('change', filter);
    inpZoek.addEventListener('input', filter);
    chips.forEach(function(c){
      c.addEventListener('click', function(){
        selCat.value = (selCat.value === c.dataset.chip) ? '' : c.dataset.chip;
        filter();
      });
    });
    finder.querySelector('[data-reset]').addEventListener('click', function(){
      selMerk.value = ''; selCat.value = ''; inpZoek.value = '';
      vulModellen(); filter();
    });

    uitLink();
    filter();
  });
})();

/* Openingsmoment: zodra de pagina er is, mag de tekst in beeld komen */
(function(){
  var html = document.documentElement;
  function start(){ html.classList.add('is-ready'); }
  if(document.readyState === 'complete') start();
  else window.addEventListener('load', start);
  setTimeout(start, 900);
})();

/* Nieuwsbrief popup: na een paar seconden, één keer per bezoeker */
(function(){
  var p = document.querySelector('[data-popup]');
  var KEY = 'snijders_nieuwsbrief';
  function lees(){ try { return localStorage.getItem(KEY); } catch(e){ return null; } }
  function schrijf(v){ try { localStorage.setItem(KEY, v); } catch(e){} }
  if(/customer_posted=true/.test(location.search)) schrijf(String(Date.now() + 365*864e5));
  if(!p) return;
  var tot = parseInt(lees() || '0', 10);
  if(tot && tot > Date.now()) return;
  var delay = (parseInt(p.dataset.delay, 10) || 10) * 1000;
  var dagen = parseInt(p.dataset.days, 10) || 30;
  function sluit(){
    p.classList.remove('is-open');
    setTimeout(function(){ p.hidden = true; }, 400);
    document.body.classList.remove('no-scroll');
    schrijf(String(Date.now() + dagen*864e5));
  }
  function open(){
    if(document.querySelector('.drawer.is-open')) { setTimeout(open, 3000); return; }
    p.hidden = false;
    requestAnimationFrame(function(){ p.classList.add('is-open'); });
    var veld = p.querySelector('input[type=email]');
    if(veld && window.innerWidth > 680) setTimeout(function(){ veld.focus(); }, 500);
  }
  p.querySelectorAll('[data-popup-close]').forEach(function(b){ b.addEventListener('click', sluit); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !p.hidden) sluit(); });
  var f = p.querySelector('form');
  if(f) f.addEventListener('submit', function(){ schrijf(String(Date.now() + 365*864e5)); });
  setTimeout(open, delay);
})();
